import { useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import CardBody from 'components/Card/CardBody';
import CardWrapper from 'components/Card/CardWrapper';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';

export type OtherSettingsConfig = {
  '@type': string;
  demandPhoneNumber: boolean;
};

type OtherLoginSettingsCardProps = {
  config: OtherSettingsConfig;
  onChange: (config: OtherSettingsConfig) => void;
};

const OtherLoginSettingsCard = ({
  config,
  onChange,
}: OtherLoginSettingsCardProps) => {
  const { t } = useTranslation();

  return (
    <CardWrapper title={t('brands.newBrandForm.restOfLoginSettings')}>
      <CardBody>
        <Divider />
        <LabeledCheckbox
          checked={config.demandPhoneNumber}
          onChange={() =>
            onChange({
              ...config,
              demandPhoneNumber: !config.demandPhoneNumber,
            })
          }
          label={t('brands.newBrandForm.restOfLoginSettings.demandPhoneNumber')}
        />
      </CardBody>
    </CardWrapper>
  );
};

export default OtherLoginSettingsCard;
